module.exports = __webpack_public_path__ + "../PROD/appsettings.js";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=../PROD/[name].[ext]!./configs/appSettings/PROD/appsettings.js
// module id = 759
// module chunks = 1